import React from 'react'
import Hero from '../../components/hero/Hero'
import Call from '../../components/call/Call'
import Services from '../../components/services/Services'
import About from '../../components/about/About'
import Team from '../../components/team/Team'
import Partners from '../../components/partners/Partners'
import Slideshow from '../../components/slideshow/Slideshow'
import FAQs from '../../components/faqs/FAQs'
import GoogleMap from '../../components/google/GoogleMap'
import Contact from '../../components/contact/Contact'
import Footer from '../../components/footer/Footer'


const Home = () => {
  return (
    <>
     <div className='homepage'>
      <Hero />
      <Call />
      <About />
      <Services />
      <Team />
      <Partners />
      <Slideshow />
      <FAQs />
      <GoogleMap />
      <Contact />
      <Footer />
    </div>
    </>
  )
}

export default Home;